import React, { useEffect, useRef } from 'react';
import { Animated, StyleSheet, View } from 'react-native';
import { useTheme } from 'react-native-paper';

/**
 * Three pulsing dots inside an assistant-style bubble — shown while the
 * "assistant" is preparing the next question of the registration chat.
 */
export const TypingIndicator: React.FC<{ testID?: string }> = ({ testID }) => {
  const theme = useTheme();
  const dots = [useRef(new Animated.Value(0.3)).current, useRef(new Animated.Value(0.3)).current, useRef(new Animated.Value(0.3)).current];

  useEffect(() => {
    const animations = dots.map((dot, i) =>
      Animated.loop(
        Animated.sequence([
          Animated.delay(i * 160),
          Animated.timing(dot, { toValue: 1, duration: 320, useNativeDriver: true }),
          Animated.timing(dot, { toValue: 0.3, duration: 320, useNativeDriver: true }),
          Animated.delay((2 - i) * 160),
        ]),
      ),
    );
    animations.forEach(a => a.start());
    return () => animations.forEach(a => a.stop());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <View style={styles.row} testID={testID ?? 'chat-typing'}>
      <View style={[styles.bubble, { backgroundColor: theme.colors.surfaceVariant }]}>
        {dots.map((dot, i) => (
          <Animated.View
            key={i}
            style={[styles.dot, { backgroundColor: theme.colors.onSurfaceVariant, opacity: dot }]}
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    width: '100%',
    marginVertical: 4,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  bubble: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    paddingHorizontal: 14,
    paddingVertical: 14,
    borderRadius: 18,
    borderTopLeftRadius: 6,
  },
  dot: {
    width: 7,
    height: 7,
    borderRadius: 4,
  },
});

export default TypingIndicator;
